import React from 'react';
import { useSelector } from 'react-redux';
import s from './reviews.module.scss';
import users from './img/users.png';
import usersDark from './img/usersDark.png';
import locales from '../../../content.json';
import { getParameterFromURL } from '../../../utils/scripts';
import { RootState } from '../../../store';

export const Reviews = () => {
  const darkTheme = getParameterFromURL('darkTheme') === 'true';
  const puppyOnboarding = getParameterFromURL('puppyOnboarding') === 'true';
  const nutritionOnboarding = useSelector((state: RootState) => state.data.nutritionOnboarding);
  const vetOnboarding = useSelector((state: RootState) => state.data.vetOnboarding);
  const descriptionHtml = vetOnboarding
    ? locales[window.userLang].payment_text_299
    : nutritionOnboarding
    ? locales[window.userLang].payment_text_349
    : puppyOnboarding
    ? locales[window.userLang].payment_text_220
    : locales[window.userLang].payment_text_4;
  return(
    <div className={s.reviews}>
      <div className={s.usersWrapper}>
        <p className={s.numberUsers}>98%</p>
        <img className={s.usersImg} src={darkTheme ? usersDark : users} alt="users" />
      </div>
      <p className={s.description}>
        {descriptionHtml}
      </p>
    </div>
  );
};
